export function scrollToTop() {
    window.scrollTo(0, 0);
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
}



// WEBPACK FOOTER //
// ./src/common/utils/scrollUtils.js